export default __webpack_public_path__ + "static/media/Renata.97d3cdfc.jpg";